//@ts-nocheck
//@eslint-disable
import { logInfoMsg } from './index-invisible';
import session from './session';

// Dail a number
export function dailnumber(phoneNumber: any) {
  console.log('phoneNumber111', phoneNumber);
  var agent = new lily.Agent();
  agent.connect(connect.Endpoint.byPhoneNumber(phoneNumber), {});
  // agent.connect(connect.Endpoint.byPhoneNumber('+16614536887'), {});
}

// Set the agent Available
export function goAvailable() {
  var routableState = session.agent.getAgentStates().filter(function (state) {
    return state.type === connect.AgentStateType.ROUTABLE;
  })[0];
  session.agent.setState(routableState, {
    success: function () {
      logInfoMsg('Set agent status to Available (routable) via Streams');
    },
    failure: function () {
      logInfoMsg('Failed to set agent status to Available (routable) via Streams');
    },
  });
}

// Set the agent offline
export function goOffline() {
  var offlineState = session.agent.getAgentStates().filter(function (state) {
    return state.type === connect.AgentStateType.OFFLINE;
  })[0];
  session.agent.setState(offlineState, {
    success: function () {
      logInfoMsg('Set agent status to Offline via Streams');
    },
    failure: function () {
      logInfoMsg('Failed to set agent status to Offline via Streams');
    },
  });
}

// Accept the contact
export function acceptContact() {
  logInfoMsg('Accept contact');
  session.contact.accept({
    success: function () {
      logInfoMsg('Accepted contact via Streams');
    },
    failure: function () {
      logInfoMsg('Failed to accept contact via Streams');
    },
  });
}

// Disconnect the current contact
export function disconnectContact(bid?: any, durationString?: any) {
  console.log('bid,durationString1', bid, durationString);
  try {
    //cannot do contact.destroy(), can only destroy (hang-up) agent connection
    session.contact.getAgentConnection().destroy({
      success: function () {
        logInfoMsg('Disconnected contact via Streams');
        logInfoMsg('bid,durationString2' + session.contact.getContactId());
        clearContact(); // 拨打方挂断
        // if (!bid) return; 换成监听
        // followUpRecords({
        //   module: 'call',
        //   type: 6,
        //   bid: bid, // 商机id
        //   data: session.contact.getContactId(), // connectId
        //   changeContent: durationString, // 通话时长
        // }).then((res) => {
        //   if (res.success) {
        //     // message.success('Withdrawn successfully');
        //   } else {
        //     // message.error(res.message);
        //   }
        // });
      },
      failure: function () {
        logInfoMsg('bid,durationString3，Failed to disconnect contact via Streams');
      },
    });
  } catch (e) {
    logInfoMsg(e);
  }
}

// To destroy the contact when agent is in ACW
export function clearContact() {
  session.contact.clear({
    success: function () {
      logInfoMsg('Cleared contact via Streams');
    },
    failure: function () {
      logInfoMsg('Failed to clear contact via Streams');
    },
  });
}
